/* Vogue System Mix Custom: self-contained, no third-party service, no pricing. */
(function () {
  "use strict";

  var dictionaries = {
    it: {
      cm: "cm", formatHelp: "Formato nominale delle tessere. Foglio premontato: 30 × 40 cm.",
      in: "Interni (IN)", inSurface: "Opaco", tr: "Trasparenze (TR)", trSurface: "Lucido", mixed: "IN + TR", mixedSurface: "Opaco + lucido · stesso foglio",
      tenHelp: "Nel 10×10 puoi scegliere Interni opaco (IN), Trasparenze lucido (TR) oppure abbinare le due finiture (IN + TR) nello stesso foglio 30 × 40 cm.",
      fiveHelp: "Nel 5×5 puoi scegliere Interni opaco, Trasparenze lucido o mescolare le due finiture nello stesso foglio 30 × 40 cm.",
      colours: "colori", slots: "Colore", paletteHelp: "Seleziona uno spazio colore, poi scegli una piastrella dalla palette originale.",
      colourAlert: "Per un mix IN + TR occorre almeno un colore di ciascuna finitura.",
      noData: "La palette originale Vogue System non è disponibile. Riprova più tardi.",
      sheet: "Foglio", surface: "Superficie", regenerate: "Rigenera la distribuzione",
      share: "Copia link al progetto", shared: "Link copiato", copyFailure: "Impossibile copiare automaticamente: copia l'indirizzo dalla barra del browser.",
      format: "Formato", finish: "Finitura", layout: "Schema", chess: "Scacchiera", random: "Miscelazione casuale",
      composition: "Composizione", sheetSize: "Foglio", percent: "circa", invalid: "Combinazione da completare.",
      message: "Richiesta di fattibilità System Mix Custom", note: "Note cliente", link: "Link al progetto",
      id: "Codice simulazione", ready: "Mix pronto per la verifica commerciale/tecnica.",
      company: "Società", country: "Nazione", privacyRecord: "Presa visione privacy (UTC)"
    },
    en: {
      cm: "cm", formatHelp: "Nominal tile size. Mesh-mounted sheet: 30 × 40 cm.",
      in: "Interni (IN)", inSurface: "Matte", tr: "Trasparenze (TR)", trSurface: "Glossy", mixed: "IN + TR", mixedSurface: "Matte + glossy · same sheet",
      tenHelp: "For 10×10 choose matte Interni (IN), glossy Trasparenze (TR), or combine both finishes (IN + TR) on the same 30 × 40 cm sheet.",
      fiveHelp: "For 5×5 choose matte Interni, glossy Trasparenze, or mix both finishes on the same 30 × 40 cm sheet.",
      colours: "colours", slots: "Colour", paletteHelp: "Select a colour slot, then choose an original tile from the palette.",
      colourAlert: "An IN + TR mix requires at least one colour from each finish.",
      noData: "The original Vogue System palette is unavailable. Please try again later.",
      sheet: "Sheet", surface: "Surface", regenerate: "Regenerate distribution",
      share: "Copy project link", shared: "Link copied", copyFailure: "Cannot copy automatically; copy the address from your browser.",
      format: "Size", finish: "Finish", layout: "Layout", chess: "Checkerboard", random: "Random mix",
      composition: "Composition", sheetSize: "Sheet", percent: "approx.", invalid: "Please complete the combination.",
      message: "System Mix Custom feasibility request", note: "Customer notes", link: "Project link",
      id: "Simulation code", ready: "Your mix is ready for commercial / technical review.",
      company: "Company", country: "Country", privacyRecord: "Privacy acknowledgement (UTC)"
    },
    fr: {
      cm: "cm", formatHelp: "Dimensions nominales des tesselles. Feuille sur trame : 30 × 40 cm.",
      in: "Interni (IN)", inSurface: "Mat", tr: "Trasparenze (TR)", trSurface: "Brillant", mixed: "IN + TR", mixedSurface: "Mat + brillant · même feuille",
      tenHelp: "En 10×10, choisissez Interni mat (IN), Trasparenze brillant (TR) ou combinez les deux finitions (IN + TR) sur la même feuille de 30 × 40 cm.",
      fiveHelp: "En 5×5, choisissez Interni mat, Trasparenze brillant, ou combinez les deux finitions sur la même feuille de 30 × 40 cm.",
      colours: "couleurs", slots: "Couleur", paletteHelp: "Sélectionnez un emplacement, puis une couleur de la palette originale.",
      colourAlert: "Un mélange IN + TR doit contenir au moins une couleur de chaque finition.",
      noData: "La palette Vogue System d'origine est indisponible. Réessayez plus tard.",
      sheet: "Feuille", surface: "Surface", regenerate: "Redistribuer les couleurs",
      share: "Copier le lien du projet", shared: "Lien copié", copyFailure: "Copie impossible : copiez l'adresse depuis votre navigateur.",
      format: "Format", finish: "Finition", layout: "Motif", chess: "Damier", random: "Mélange aléatoire",
      composition: "Composition", sheetSize: "Feuille", percent: "env.", invalid: "Veuillez compléter le mélange.",
      message: "Demande de faisabilité System Mix Custom", note: "Notes du client", link: "Lien du projet",
      id: "Code de simulation", ready: "Mélange prêt pour vérification commerciale / technique.",
      company: "Société", country: "Pays", privacyRecord: "Acceptation de la politique de confidentialité (UTC)"
    },
    de: {
      cm: "cm", formatHelp: "Nennformat der Fliesen. Netzgeklebte Matte: 30 × 40 cm.",
      in: "Interni (IN)", inSurface: "Matt", tr: "Trasparenze (TR)", trSurface: "Glänzend", mixed: "IN + TR", mixedSurface: "Matt + glänzend · gleiche Matte",
      tenHelp: "Bei 10×10 wählen Sie Interni matt (IN), Trasparenze glänzend (TR) oder kombinieren beide Oberflächen (IN + TR) auf derselben 30 × 40 cm Matte.",
      fiveHelp: "Bei 5×5 können Interni matt und Trasparenze glänzend einzeln oder gemeinsam auf derselben 30 × 40 cm Matte verwendet werden.",
      colours: "Farben", slots: "Farbe", paletteHelp: "Wählen Sie einen Farbplatz und dann eine Originalfarbe aus der Palette.",
      colourAlert: "Ein IN + TR Mix muss mindestens eine Farbe aus jeder Oberfläche enthalten.",
      noData: "Die originale Vogue System Farbpalette ist nicht verfügbar. Versuchen Sie es später erneut.",
      sheet: "Matte", surface: "Fläche", regenerate: "Verteilung neu erstellen",
      share: "Projektlink kopieren", shared: "Link kopiert", copyFailure: "Automatisches Kopieren nicht möglich; bitte Browseradresse kopieren.",
      format: "Format", finish: "Oberfläche", layout: "Verlegung", chess: "Schachbrett", random: "Zufällige Mischung",
      composition: "Zusammensetzung", sheetSize: "Matte", percent: "ca.", invalid: "Bitte vervollständigen Sie den Mix.",
      message: "System Mix Custom Machbarkeitsanfrage", note: "Kundennotiz", link: "Projektlink",
      id: "Simulationscode", ready: "Mix bereit zur kaufmännischen / technischen Prüfung.",
      company: "Unternehmen", country: "Land", privacyRecord: "Datenschutzbestätigung (UTC)"
    }
  };

  function init(root) {
    if (root.getAttribute("data-gsmc-initialized") === "true") return;
    root.setAttribute("data-gsmc-initialized", "true");

    var lang = root.getAttribute("data-lang") || "it";
    var t = dictionaries[lang] || dictionaries.it;
    var node = function (selector) { return root.querySelector(selector); };
    var payload = node("[data-gsmc-data]");
    var palette;
    try {
      palette = JSON.parse(payload.textContent).colours || [];
    } catch (err) {
      palette = [];
    }
    palette = palette.filter(function (c) {
      return c && typeof c.id === "string" && typeof c.name === "string" &&
        (c.finish === "IN" || c.finish === "TR") &&
        (typeof c.image === "string" || c.image === null);
    });

    var byId = {};
    palette.forEach(function (colour) { byId[colour.id] = colour; });
    var preferred = ["ghiaccio", "seta", "tortora", "latte", "perla"];
    function priority(colour) {
      var order = preferred.indexOf(colour.name.toLocaleLowerCase());
      return order < 0 ? 99 : order;
    }
    function sorted(list) {
      return list.slice().sort(function (a, b) {
        return priority(a) - priority(b) ||
          a.name.localeCompare(b.name, lang);
      });
    }

    var state = {
      size: 5, finish: "IN", count: 3, selected: [], active: 0,
      seed: Math.floor(Math.random() * 1000000000), view: "sheet"
    };
    function allowed() {
      return palette.filter(function (colour) {
        return state.finish === "MIX" || colour.finish === state.finish;
      });
    }
    function autoPick(previous) {
      var chosen = (previous || []).filter(function (id, i, a) {
        return !!byId[id] && allowed().some(function (c) { return c.id === id; }) && a.indexOf(id) === i;
      }).slice(0, state.count);
      var ordered = sorted(allowed());
      if (state.finish === "MIX") {
        var hasIn = chosen.some(function (id) { return byId[id].finish === "IN"; });
        var hasTr = chosen.some(function (id) { return byId[id].finish === "TR"; });
        var inColour = ordered.find(function (c) { return c.finish === "IN" && chosen.indexOf(c.id) < 0; });
        var trColour = ordered.find(function (c) { return c.finish === "TR" && chosen.indexOf(c.id) < 0; });
        if (!hasIn && inColour) {
          if (chosen.length >= state.count) chosen.pop();
          chosen.push(inColour.id);
        }
        if (!hasTr && trColour) {
          if (chosen.length >= state.count) {
            var replace = chosen.findIndex(function (id) { return byId[id].finish === "IN"; });
            if (replace < 0 || chosen.filter(function (id) { return byId[id].finish === "IN"; }).length > 1) {
              chosen.splice(replace < 0 ? chosen.length - 1 : replace, 1);
            } else {
              chosen.pop();
            }
          }
          chosen.push(trColour.id);
        }
      }
      ordered.forEach(function (colour) {
        if (chosen.length < state.count && chosen.indexOf(colour.id) < 0) chosen.push(colour.id);
      });
      return chosen.slice(0, state.count);
    }
    function valid() {
      if (state.selected.length !== state.count || state.selected.some(function (id) { return !byId[id]; })) return false;
      if (state.finish === "MIX") {
        return state.selected.some(function (id) { return byId[id].finish === "IN"; }) &&
          state.selected.some(function (id) { return byId[id].finish === "TR"; });
      }
      return state.selected.every(function (id) { return byId[id].finish === state.finish; });
    }

    // Restore a sharable design, accepting only IDs from the official palette.
    try {
      var query = new URLSearchParams(window.location.search);
      var requestedSize = Number(query.get("size"));
      var requestedFinish = query.get("finish");
      var requestedIds = (query.get("c") || "").split(",").filter(Boolean);
      var requestedSeed = Number(query.get("seed"));
      if (requestedSize === 5 || requestedSize === 10) state.size = requestedSize;
      if (["IN", "TR", "MIX"].indexOf(requestedFinish) >= 0) state.finish = requestedFinish;
      if (requestedIds.length >= 2 && requestedIds.length <= 4 &&
        requestedIds.every(function (id) {
          return !!byId[id] && (state.finish === "MIX" || byId[id].finish === state.finish);
        }) && new Set(requestedIds).size === requestedIds.length) {
        state.count = requestedIds.length;
        state.selected = requestedIds;
      }
      if (Number.isInteger(requestedSeed) && requestedSeed > 0 && requestedSeed < 2147483647) state.seed = requestedSeed;
    } catch (err) { /* Missing URLSearchParams: use defaults. */ }
    state.selected = autoPick(state.selected);

    function el(tag, className, textValue) {
      var out = document.createElement(tag);
      if (className) out.className = className;
      if (textValue !== undefined) out.textContent = textValue;
      return out;
    }
    function clear(parent) { while (parent.firstChild) parent.removeChild(parent.firstChild); }
    function choice(textValue, active, callback, subtitle) {
      var button = el("button", "gsmc__choice", textValue);
      button.type = "button";
      button.setAttribute("aria-pressed", String(active));
      if (subtitle) button.appendChild(el("small", "", subtitle));
      button.addEventListener("click", callback);
      return button;
    }
    function changeSize(value) {
      if (state.size === value) return;
      state.size = value;
      state.selected = autoPick(state.selected);
      state.active = 0;
      render();
    }
    function changeFinish(value) {
      if (state.finish === value) return;
      state.finish = value;
      state.selected = autoPick(state.selected);
      state.active = 0;
      render();
    }
    function changeCount(value) {
      state.count = value;
      state.selected = autoPick(state.selected);
      state.active = Math.min(state.active, value - 1);
      render();
    }

    function renderOptions() {
      var formats = node("[data-gsmc-formats]");
      var finishes = node("[data-gsmc-finishes]");
      var counts = node("[data-gsmc-counts]");
      clear(formats); clear(finishes); clear(counts);
      [5, 10].forEach(function (size) {
        formats.appendChild(choice(size + " × " + size + " cm", state.size === size,
          function () { changeSize(size); }));
      });
      [["IN", t.in, t.inSurface], ["TR", t.tr, t.trSurface], ["MIX", t.mixed, t.mixedSurface]].forEach(function (item) {
        finishes.appendChild(choice(item[1], state.finish === item[0],
          function () { changeFinish(item[0]); }, item[2]));
      });
      [2, 3, 4].forEach(function (count) {
        counts.appendChild(choice(count + " " + t.colours, state.count === count,
          function () { changeCount(count); }));
      });
      node("[data-gsmc-finish-hint]").textContent =
        state.size === 10 ? t.tenHelp : t.fiveHelp;
      node("[data-gsmc-colour-hint]").textContent = t.paletteHelp;
    }
    function renderSlots() {
      var holder = node("[data-gsmc-slots]");
      clear(holder);
      state.selected.forEach(function (id, index) {
        var colour = byId[id];
        var slot = el("button", "gsmc__slot");
        slot.type = "button";
        slot.setAttribute("aria-pressed", String(state.active === index));
        slot.setAttribute("aria-label", t.slots + " " + (index + 1) + ": " + colour.name + " " + colour.finish);
        var content = el("span", "gsmc__slot-top");
        var thumb = el("span", "gsmc__slot-thumb");
        if (colour.finish === "TR") thumb.classList.add("gsmc__gloss");
        if (colour.image) {
          var image = el("img");
          image.src = colour.image;
          image.alt = "";
          image.loading = "lazy";
          thumb.appendChild(image);
        }
        content.appendChild(thumb);
        var copy = el("span", "gsmc__slot-copy");
        copy.appendChild(el("span", "gsmc__slot-index", t.slots + " " + (index + 1)));
        var name = el("span", "gsmc__slot-name", colour.name);
        name.appendChild(el("span", "gsmc__slot-finish", " " + colour.finish));
        copy.appendChild(name);
        content.appendChild(copy);
        slot.appendChild(content);
        slot.addEventListener("click", function () {
          state.active = index;
          renderSlots(); renderPalette();
        });
        holder.appendChild(slot);
      });
    }
    function renderPalette() {
      var holder = node("[data-gsmc-palette]");
      var savedScroll = holder.scrollTop;
      clear(holder);
      sorted(allowed()).forEach(function (colour) {
        var selectedAt = state.selected.indexOf(colour.id);
        var button = el("button", "gsmc__swatch");
        button.type = "button";
        button.setAttribute("aria-pressed", String(selectedAt >= 0));
        button.setAttribute("aria-label", colour.name + " (" + colour.finish + ")");
        var tile = el("span", "gsmc__swatch-image");
        if (colour.finish === "TR") tile.classList.add("gsmc__gloss");
        if (colour.image) {
          var img = el("img");
          img.src = colour.image;
          img.alt = "";
          img.loading = "lazy";
          tile.appendChild(img);
        }
        button.appendChild(tile);
        button.appendChild(el("span", "gsmc__swatch-label", colour.name));
        button.appendChild(el("span", "gsmc__swatch-code", colour.finish));
        button.addEventListener("click", function () {
          var currentIndex = state.active;
          if (selectedAt >= 0 && selectedAt !== currentIndex) {
            state.selected[selectedAt] = state.selected[currentIndex];
          }
          state.selected[currentIndex] = colour.id;
          state.active = (currentIndex + 1) % state.count;
          renderSlots(); renderPalette(); renderPreview();
        });
        holder.appendChild(button);
      });
      holder.scrollTop = savedScroll;
    }

    // Every sheet has precisely balanced, deterministic tile counts.
    function shuffledTiles(sheetIndex) {
      var cols = state.size === 5 ? 6 : 3;
      var rows = state.size === 5 ? 8 : 4;
      var count = cols * rows;
      var selected = state.selected;
      var ids = [];
      if (selected.length === 2) {
        var phase = (sheetIndex % 2) * cols + Math.floor(sheetIndex / 2) * rows;
        for (var y = 0; y < rows; y++) {
          for (var x = 0; x < cols; x++) {
            ids.push(selected[(x + y + phase) % 2]);
          }
        }
        return ids;
      }
      for (var i = 0; i < count; i++) ids.push(selected[i % selected.length]);
      var seed = (state.seed + sheetIndex * 7919) >>> 0;
      function rng() {
        seed += 0x6D2B79F5;
        var t = seed;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }
      for (var j = ids.length - 1; j > 0; j--) {
        var k = Math.floor(rng() * (j + 1));
        var temp = ids[j]; ids[j] = ids[k]; ids[k] = temp;
      }
      return ids;
    }
    function makeSheet(index) {
      var sheet = el("div", "gsmc__sheet");
      sheet.style.setProperty("--gsmc-cols", state.size === 5 ? "6" : "3");
      sheet.style.setProperty("--gsmc-rows", state.size === 5 ? "8" : "4");
      shuffledTiles(index).forEach(function (id) {
        var tile = el("span", "gsmc__tile");
        var colour = byId[id];
        if (colour && colour.finish === "TR") tile.classList.add("gsmc__gloss");
        if (colour && colour.image) {
          tile.style.backgroundImage = "url(" + JSON.stringify(colour.image) + ")";
        }
        sheet.appendChild(tile);
      });
      return sheet;
    }
    function projectUrl() {
      var url = new URL(window.location.href);
      ["size", "finish", "c", "seed"].forEach(function (key) { url.searchParams.delete(key); });
      url.searchParams.set("size", String(state.size));
      url.searchParams.set("finish", state.finish);
      url.searchParams.set("c", state.selected.join(","));
      url.searchParams.set("seed", String(state.seed));
      return url.toString();
    }
    function finishDescription(value) {
      if (value === "IN") return t.inSurface;
      if (value === "TR") return t.trSurface;
      return t.mixedSurface;
    }
    function summaryText() {
      var out = [
        t.message,
        t.format + ": " + state.size + " × " + state.size + " cm",
        t.finish + ": " + state.finish + " (" + finishDescription(state.finish) + ")",
        t.sheetSize + ": 30 × 40 cm",
        t.layout + ": " + (state.count === 2 ? t.chess : t.random),
        t.composition + ":"
      ];
      state.selected.forEach(function (id) {
        var colour = byId[id];
        if (colour) out.push("- " + colour.finish + " " + colour.name + ": " +
          t.percent + " " + (Math.round(1000 / state.count) / 10) + "%");
      });
      out.push(t.id + ": " + state.size + "-" + state.finish + "-" + state.seed);
      out.push(t.link + ": " + projectUrl());
      return out.join("\n");
    }
    function renderPreview() {
      var stage = node("[data-gsmc-stage]");
      var summary = node("[data-gsmc-summary]");
      var warning = node("[data-gsmc-warning]");
      clear(stage); clear(summary);
      var ready = valid();
      warning.textContent = palette.length === 0 ? t.noData :
        ready ? "" : (state.finish === "MIX" ? t.colourAlert : t.invalid);
      stage.classList.toggle("gsmc__sheet-stage--surface", state.view === "surface");
      if (ready) {
        for (var n = 0; n < (state.view === "surface" ? 4 : 1); n++) {
          stage.appendChild(makeSheet(n));
        }
      }
      stage.setAttribute("aria-label", ready ? summaryText() : t.invalid);
      var header = el("div", "", t.format + ": " + state.size + " × " + state.size +
        " cm · " + t.finish + ": " + state.finish + " · " + finishDescription(state.finish));
      summary.appendChild(header);
      summary.appendChild(el("div", "", t.sheetSize + ": 30 × 40 cm · " + t.layout + ": " +
        (state.count === 2 ? t.chess : t.random)));
      var list = el("ul");
      state.selected.forEach(function (id) {
        var colour = byId[id];
        if (!colour) return;
        var li = el("li");
        var dot = el("span", "gsmc__colour-dot");
        if (colour.finish === "TR") dot.classList.add("gsmc__gloss");
        if (colour.image) dot.style.backgroundImage = "url(" + JSON.stringify(colour.image) + ")";
        li.appendChild(dot);
        li.appendChild(el("span", "", colour.finish + " " + colour.name + " — " +
          t.percent + " " + (Math.round(1000 / state.count) / 10) + "%"));
        list.appendChild(li);
      });
      summary.appendChild(list);
      var send = node("[data-gsmc-send]");
      if (send) send.disabled = !ready;
      var body = node("[data-gsmc-contact-body]");
      if (body) body.value = ready ? summaryText() : "";
    }
    function renderViewButtons() {
      var target = node("[data-gsmc-views]");
      clear(target);
      [["sheet", t.sheet], ["surface", t.surface]].forEach(function (item) {
        target.appendChild(choice(item[1], state.view === item[0], function () {
          state.view = item[0];
          renderViewButtons();
          renderPreview();
        }));
      });
    }
    function render() {
      renderOptions();
      renderSlots();
      renderPalette();
      renderViewButtons();
      renderPreview();
    }

    var regen = node("[data-gsmc-regenerate]");
    regen.textContent = t.regenerate;
    regen.addEventListener("click", function () {
      state.seed = Math.floor(Math.random() * 2000000000) + 1;
      renderPreview();
    });
    var share = node("[data-gsmc-share]");
    share.textContent = t.share;
    share.addEventListener("click", function () {
      var address = projectUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(address).then(function () {
          share.textContent = t.shared;
        }).catch(function () {
          share.textContent = t.copyFailure;
        });
      } else {
        share.textContent = t.copyFailure;
      }
    });
    var form = root.querySelector(".gsmc__enquiry form");
    if (form) {
      form.addEventListener("submit", function (event) {
        if (!valid()) {
          event.preventDefault();
          node("[data-gsmc-warning]").textContent = t.invalid;
          return;
        }
        var note = node("[data-gsmc-project-note]").value.trim();
        var company = node("[data-gsmc-company]").value.trim();
        var country = node("[data-gsmc-country]").value.trim();
        var bodyParts = [summaryText()];
        if (country) bodyParts.push("", t.country + ": " + country);
        if (company) bodyParts.push(t.company + ": " + company);
        if (note) bodyParts.push("", t.note + ":", note);
        bodyParts.push("", t.privacyRecord + ": " + new Date().toISOString());
        node("[data-gsmc-contact-body]").value = bodyParts.join("\n");
      });
    }
    render();
  }
  function boot() {
    document.querySelectorAll("[data-gsmc]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();